const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const viewClass = require('./view');
const modelClass = require('./model');
const ShoppingCart = require('od-modules/cart/cart');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

module.exports = createWidgetFactory({
    name: 'fare_rules',
    modelClass,
    viewClass,
    methods: {
        hasErrors() {
            return this.model.hasErrors();
        },
        addClassicFareRule() {
            if (this.model.mustAddClassic()) {
                this.model.addClassicFareRule();
                this.loadFareRules();
            }
        },
        onFareRulesLoaded({sendPriceShellEvent = false} = {}) {
            this.model.set('fareRulesEnabled', true);
            ShoppingCart.addTracking({
                fareRules: {
                    loaded: true,
                },
            });
            this.trackOnLoad();
            if (sendPriceShellEvent) {
                this.sendPriceShellEvent();
            }
        },
        onFareRulesLoadedOF2({sendPriceShellEvent = false} = {}) {
            this.model.set('fareRulesEnabled', true);
            if (sendPriceShellEvent) {
                this.sendPriceShellEvent();
            }
        },
        onFareRuleSelect(data = {}) {
            const {event} = data || {};
            this.model.onFareRuleSelect(data);
            trackClickEvent(event);
        },
        onFareRuleSelectOF2(data = {}) {
            this.model.onFareRuleSelectOF2(data);
        },
        showFareRulesErrors(container) {
            this.showFareRulesErrors(container);
        },
        showFareRulesErrorsOF2(container) {
            this.showFareRulesErrorsOF2(container);
        },
        updateFareRules() {
            this.updateFareRules();
        },
        updateFareRulesIfHasMembershipDetails() {
            this.updateFareRulesIfHasMembershipDetails();
        },
        trackFareRulesContinue(data = {}) {
            this.model.trackFareRulesContinue(data);
        },
        getPrice() {
            return this.model.getPrice();
        },
    },
});
